// extracted by mini-css-extract-plugin
export default {"hideTooltip":"G9-z","fadeIn":"H9-z","delay":"I9-z","recommendedSizeTooltip":"J9-z"};